export enum AdminBannerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
